import { Reducer } from 'redux';
import {
  EquipmentCategories,
  EquipmentImageUpload,
  EquipmentItem,
  EquipmentList,
  FilterEquipmentList,
  initialEquipmentState,
  TEquipmentActions,
  TEquipmentState,
} from '../types/Equipment';
import { endReducer } from '../store/Store';

export const equipmentReducer: Reducer<
  TEquipmentState,
  TEquipmentActions
> = (state = initialEquipmentState, action) => {
  switch (action.type) {
    case EquipmentCategories.SUCCESS: {
      return {
        ...state,
        categories: action.payload.data.categories,
      };
    }

    case EquipmentCategories.FAILED:
      return state;

    case EquipmentList.REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case EquipmentList.SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data.equipment,
        filteredList: action.payload.data.equipment,
      };
    }

    case EquipmentList.FAILED:
      return {
        ...state,
        loading: false,
      };

    case EquipmentItem.REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case EquipmentItem.SUCCESS: {
      return {
        ...state,
        loading: false,
        activeEquipment: {
          data: action.payload.data.equipment,
          ppe: action.payload.data.ppe,
          prohibitions: action.payload.data.prohibitions,
          latestService: action.payload.data.latestService,
          nextServiceDate: action.payload.data.nextServiceDate,
        },
      };
    }

    case EquipmentItem.FAILED:
      return {
        ...state,
        loading: false,
      };

    case EquipmentImageUpload.SUCCESS: {
      if (!state.activeEquipment) {
        return state;
      }

      return {
        ...state,
        activeEquipment: {
          ...state.activeEquipment,
          data: {
            ...state.activeEquipment.data,
            image: action.payload.data.image,
          },
        },
      };
    }

    case FilterEquipmentList.SUBMIT: {
      const searchPhrase = action.payload.search.toLocaleLowerCase();
      const locationFilter = action.payload.location;

      return {
        ...state,
        filteredList: state.data?.filter((val) => {
          const matchesSearch = val.name.toLocaleLowerCase().includes(searchPhrase);
          const matchesLocation = !locationFilter || val.locations.some(
            (loc) => loc.title === locationFilter
          );
          return matchesSearch && matchesLocation;
        }),
        searchPhrase,
      };
    }

    default:
      return endReducer(state, action);
  }
};
